import React from 'react'

interface Props {
  handleOpenQuotationModal: any,
  isAsoleacionModalOpened: boolean
  isQuotationModalOpened: boolean
}

interface State {

}

class QuotationBtnMobile extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {}
  }

  render(): React.ReactNode {
      return(
        <div 
          className={this.props.isAsoleacionModalOpened || this.props.isQuotationModalOpened ? "quotation-btn-container-mobile fade-out":"quotation-btn-container-mobile fade-im"}
          onClick = {() => {this.props.handleOpenQuotationModal()}}
        >
          Cotiza
        </div>
      )
  }
}

export default QuotationBtnMobile